//import TopYearMonthArea from "@/pcomponents/common/crud/calendar/area/top_year_month";
import strFunc from '@/lib/lyg/string';
import left_arrow_ico from "@/img/ico/arrow/left_arrow.png";
import right_arrow_ico from "@/img/ico/arrow/right_arrow.png";
import DateFunc from '@/lib/lyg/date_func';

function TopYearMonthArea(props: any) {
  let myProps = {
    select_date: "",
    set_select_date: (inData: any) => { },
    center_y: true,
    center_m: true,
    center_d: false,
    is_show_month_arrow: true,
    is_show_day_arrow: false,
    left_right_text_period: "month",//day, month
    sub_addon_text:"",
    ...props
  };
  let select_date_json = DateFunc.get_date_json(new Date(myProps.select_date));
  let now_ymd=DateFunc.get_date_format(new Date(),"Y-m-d");
  let pre_month_date_json = DateFunc.get_date_json(DateFunc.get_change_date(new Date(myProps.select_date.substring(0, 7) + "-01"), 'month', -1));
  let after_month_date_json = DateFunc.get_date_json(DateFunc.get_change_date(new Date(myProps.select_date.substring(0, 7) + "-01"), 'month', +1));
  let pre_day_date_json = DateFunc.get_date_json(DateFunc.get_change_date(new Date(myProps.select_date), 'day', -1));
  let after_day_date_json = DateFunc.get_date_json(DateFunc.get_change_date(new Date(myProps.select_date), 'day', +1));
  let left_text = pre_month_date_json["Y"] + "년 " + pre_month_date_json.m + "월";
  let right_text = after_month_date_json["Y"] + "년 " + after_month_date_json.m + "월";
  if (myProps.left_right_text_period == "day") {
    left_text = pre_day_date_json.m + "월 " + pre_day_date_json.d + "일";
    right_text = after_day_date_json.m + "월 " + after_day_date_json.d + "일";
  }

  const goPrevAfterMonth = (sort: "prev" | "after", period: any) => {
    let select_month_obj = new Date(myProps.select_date.substring(0, 7) + "-01");
    let change_date_str = "";
    if (period == "month") {
      if (sort == "prev") {
        change_date_str = DateFunc.get_date_format(DateFunc.get_change_date(select_month_obj, 'month', -1), "Y-m-d");
      } else {
        change_date_str = DateFunc.get_date_format(DateFunc.get_change_date(select_month_obj, 'month', +1), "Y-m-d");
      }
    } else if (period == "day") {
      if (sort == "prev") {
        change_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(myProps.select_date), 'day', -1), "Y-m-d");
      } else {
        change_date_str = DateFunc.get_date_format(DateFunc.get_change_date(new Date(myProps.select_date), 'day', +1), "Y-m-d");
      }
    }
    myProps.set_select_date(change_date_str);
  };

  const handleDateChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;

    let change_searchDate = myProps.select_date;
    let tmp_year = change_searchDate.substring(0, 4);
    let tmp_month = change_searchDate.substring(5, 7);
    let tmp_day = change_searchDate.substring(8, 10);
    let tmp_date_json: any = DateFunc.get_date_json(new Date(change_searchDate));
    if (name == "s_month") {
      tmp_month = value;
    } else if (name == "s_year") {
      tmp_year = value;
    } else if (name == "s_day") {
      tmp_day = value;
    }
    if (parseInt(tmp_day) > tmp_date_json.last_day) {
      tmp_day = strFunc.str_pad({ "str": tmp_date_json.last_day, "pad_length": 2 });
    }
    change_searchDate = tmp_year + "-" + tmp_month + "-" + tmp_day;

    myProps.set_select_date(change_searchDate);
  };

  let year_num_arr = [];
  let select_year_num = parseInt(myProps.select_date.substring(0, 4));
  for (let i = select_year_num - 50; i <= select_year_num + 10; i++) {
    year_num_arr.push(i);
  }
  const year_options_tag = year_num_arr.map((item, idx) => {
    return (
      <option value={item} key={idx}>{item}</option>
    );
  });

  let month_num_arr = [];
  for (let i = 1; i <= 12; i++) {
    month_num_arr.push(i);
  }
  const month_options_tag = month_num_arr.map((item: any, idx: number) => {
    let month_val = strFunc.str_pad({ "str": item, "pad_length": 2 });
    return (
      <option value={month_val} key={idx}>{item}</option>
    );
  });

  let day_num_arr = [];
  for (let i = 0; i < select_date_json.t; i++) {
    day_num_arr.push(i + 1);
  }
  const day_options_tag = day_num_arr.map((item: any, idx: number) => {
    let day_val = strFunc.str_pad({ "str": item, "pad_length": 2 });
    return (
      <option value={day_val} key={idx}>{item}</option>
    );
  });

  return (
    <div className="top_year_month_wrap">
      <div className="year_span_wrap">
        <span className="top_year_month_side_span mr-2">
          {left_text}
        </span>
        {myProps.is_show_month_arrow &&
          <span className="year_arrow_btn" onClick={() => { goPrevAfterMonth("prev", "month"); }}>
            <img src={left_arrow_ico} />
          </span>
        }
        {myProps.is_show_day_arrow &&
          <span className="year_arrow_btn"
            onClick={() => { goPrevAfterMonth("prev", "day"); }}>
            <img src={left_arrow_ico} />
          </span>
        }
        <span className="center_ym_span">
          <div>
            {myProps.center_y &&
              <>
                <select name="s_year" value={myProps.select_date.substring(0, 4)} onChange={handleDateChange}>
                  {year_options_tag}
                </select>년
              </>
            }
            {myProps.center_m &&
              <>
                <select className="ml-1" name="s_month" value={myProps.select_date.substring(5, 7)} onChange={handleDateChange}>
                  {month_options_tag}
                </select>월
              </>
            }
            {myProps.center_d &&
              <>
                <select className="ml-1" name="s_day"
                  value={strFunc.str_pad({ "str": select_date_json.d, "pad_length": 2 })} onChange={handleDateChange}>
                  {day_options_tag}
                </select>일
              </>
            }
          </div>
        </span>
        {myProps.is_show_day_arrow &&
          <span className="year_arrow_btn"
            onClick={() => { goPrevAfterMonth("after", "day"); }}>
            <img src={right_arrow_ico} />
          </span>
        }
        {myProps.is_show_month_arrow &&
          <span className="year_arrow_btn" onClick={() => { goPrevAfterMonth("after", "month"); }}>
            <img src={right_arrow_ico} />
          </span>
        }
        <span className="top_year_month_side_span ml-2">
          {right_text}
        </span>
      </div>
      <div className="text-center main_text_color" style={{position:"relative"}}>
        {DateFunc.get_day_str_by_day_num(select_date_json.day)}
        {now_ymd==myProps.select_date &&
          <span className="ml-1">(오늘)</span>
        }
        {myProps.sub_addon_text}
      </div>
    </div>
  );
}
export default TopYearMonthArea;